/*jshint esversion: 6 */

var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
var randomUniqueId = randLetter + Date.now();
var keywords = new Bloodhound({
    name: 'keywords-' + randomUniqueId,
    datumTokenizer: Bloodhound.tokenizers.whitespace,
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    // url points to a json file that contains an array of country names, see
    // https://github.com/twitter/typeahead.js/blob/gh-pages/data/countries.json
    prefetch: '/wp-json/themetraders/v1/prop?' + randomUniqueId
});

function updatePropFilterForm(callback) {

    let urlBuilder = "/props";

    if (document.getElementById("propSearchCategory").value) {
        urlBuilder += "/category/" + document.getElementById("propSearchCategory").value;
    }

    if (document.getElementById("propSearchTheme").value) {
        urlBuilder += "/theme/" + document.getElementById("propSearchTheme").value;
    }

    urlBuilder = urlBuilder.replace(/\s+/g, "-").toLowerCase();

    if (document.getElementById("propSearchSort") || document.getElementById("propSearchKeyword").value) {
        urlBuilder += "?";
    }

    if (document.getElementById("propSearchSort")) {
        let filterSort = document.getElementById("propSearchSort").value;
        filterSort = filterSort.replace(/ /g, "+");
        urlBuilder += "sort=" + filterSort;
    }

    if (document.getElementById("propSearchSort") && document.getElementById("propSearchKeyword").value) {
        urlBuilder += "&";
    }

    if (document.getElementById("propSearchKeyword").value) {
        let filterKeyword = document.getElementById("propSearchKeyword").value;
        filterKeyword = filterKeyword.replace(/ /g, "+");
        urlBuilder += "k=" + filterKeyword;
    }

    history.replaceState(null, null, urlBuilder);

    var target = "#prop-wrap-search";

    $.ajax(urlBuilder, {
        beforeSend: function() {
            document.getElementById("propSearchSubmit").classList.add("prop-nav-site-search__submit-is-loading");
        },
        success: function(data) {
            $(target).html($(data).find(target).html());
            $('#propSearchKeyword').typeahead(null, {
                name: 'keywords',
                source: keywords,
                limit: 10
            });
            document.getElementById("anchorPropSearch").scrollIntoView();
        }
    });

    if (typeof callback == 'function')
        callback();

}

document.addEventListener("submit", event => {
    if (event.target.id == "propSearchFilterForm") {
        event.preventDefault();
        document.getElementById("propSearchCategory").selectedIndex = 0;
        document.getElementById("propSearchTheme").selectedIndex = 0;
        updatePropFilterForm();
    }
});

document.addEventListener("change", event => {
    if (event.target.id == "propSearchCategory" ||
        event.target.id == "propSearchTheme" ||
        event.target.id == "propSearchSort") {
        event.preventDefault();

        if (event.target.id == "propSearchCategory") {
            document.getElementById("propSearchTheme").selectedIndex = 0;
            document.getElementById("propSearchKeyword").value = "";
        }

        if (event.target.id == "propSearchTheme") {
            document.getElementById("propSearchCategory").selectedIndex = 0;
            document.getElementById("propSearchKeyword").value = "";
        }

        updatePropFilterForm();
    }
});

document.addEventListener("mouseover", event => {
    if (event.target.classList.contains("prop-item-link-info")) {
        event.target.nextElementSibling.style.display = "block";
    }
});

document.addEventListener("mouseout", event => {
    if (event.target.classList.contains("prop-item-overlay")) {
        setTimeout(() => {
            event.target.style.display = "none";
        }, 2000);
    }
});

jQuery(document).ready(function($) {
    $('#propSearchKeyword').typeahead(null, {
        name: 'keywords',
        source: keywords,
        limit: 10
    });
});
$(document).on("click", "#propSearchReset", function(event) {
    event.preventDefault();
    document.getElementById("propSearchCategory").selectedIndex = 0;
    document.getElementById("propSearchTheme").selectedIndex = 0;
    document.getElementById("propSearchKeyword").value = "";
    updatePropFilterForm();
});

$(document).on("click", "#searchAgain", function(event) {
    // event.preventDefault();
    document.getElementById("propSearchCategory").selectedIndex = 0;
    document.getElementById("propSearchTheme").selectedIndex = 0;
    document.getElementById("propSearchKeyword").value = "";
    updatePropFilterForm(function() {
        document.getElementById("propSearchKeyword").focus();
    });

});